import { useUiTranslator } from "../../../hooks/useUiTranslator";
import {
  BR,
  CN,
  DE,
  DK,
  ES,
  FR,
  HU,
  IT,
  LT,
  NL,
  PL,
  PT,
  RO,
  RU,
  SE,
  SI,
  SK,
  TR,
  US,
  VN,
} from "country-flag-icons/react/3x2";

import { JSX, ReactNode } from "react";

import { VMLanguages, useLanguage } from "@4pace-cpq/core";
import { FormControl, MenuItem, Select } from "@mui/material";

interface IFlags {
  [key: string]: ReactNode;
}

export function LanguageSelect({
  languages,
  onChange,
}: {
  languages: VMLanguages[];
  onChange: (selectedLanguageId: string) => void;
}): JSX.Element {
  const t = useUiTranslator();
  const { selectedLanguage } = useLanguage();
  const flags: IFlags = {
    "en-US": <US title="en-US" />,
    "de-DE": <DE title="de-DE" />,
    "da-DK": <DK title="da-DK" />,
    "es-ES": <ES title="es-ES" />,
    "fr-FR": <FR title="fr-FR" />,
    "hu-HU": <HU title="hu-HU" />,
    "it-IT": <IT title="it-IT" />,
    "nl-NL": <NL title="nl-NL" />,
    "pl-PL": <PL title="pl-PL" />,
    "pt-BR": <BR title="pt-BR" />,
    "pt-PT": <PT title="pt-PT" />,
    "ro-RO": <RO title="ro-RO" />,
    "ru-RU": <RU title="ru-RU" />,
    "sk-SK": <SK title="sk-SK" />,
    "sl-SI": <SI title="sl-SI" />,
    "sv-SE": <SE title="sv-SE" />,
    "zh-CN": <CN title="zh-CN" />,
    "lt-LT": <LT title="lt-LT" />,
    "tr-TR": <TR title="tr-TR" />,
    "vi-VN": <VN title="vi-VN" />,
  };

  const sortedLanguages = languages.sort((a, b) => {
    if (!a.languageCode || !b.languageCode) {
      return 0;
    }
    if (a.languageCode < b.languageCode) {
      return -1;
    }
    if (a.languageCode > b.languageCode) {
      return 1;
    }
    return 0;
  });

  return (
    <FormControl>
      <Select<string>
        value={selectedLanguage?.languageCode || ""}
        renderValue={() => {
          return flags[selectedLanguage?.languageCode || ""];
        }}
        inputProps={{
          "aria-label": t("CustomApp:select.language", "Language"),
        }}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        sx={{
          ">.MuiSelect-select": {
            width: "1.25em",
            py: "10px",
            //pl: 2,
            //pr: 4,
            fontSize: "1.25em",
            lineHeight: "1.5em",
            ">svg": {
              boxShadow:
                "0 0 20px 0 rgba(0,0,0,.33),0 0 3px 0 rgba(0, 0, 0, 0.05),0 3px 3px 0 rgba(0, 0, 0, 0.05)",
            },
          },
          ">fieldset": {
            border: "none",
          },
        }}
      >
        {sortedLanguages?.map((language) =>
          language.languageCode &&
          Object.keys(flags).includes(language.languageCode) ? (
            <MenuItem
              key={language.languageCode}
              value={language.languageCode}
              sx={{
                display: "flex",
                justifyContent: "center",
                py: ".4em",
                ">svg": {
                  width: "1.5em",
                  boxShadow:
                    "0 0 20px 0 rgba(0,0,0,.33),0 0 3px 0 rgba(0, 0, 0, 0.05),0 3px 3px 0 rgba(0, 0, 0, 0.05)",
                },

                //height: "1em",
              }}
            >
              {language.languageCode && flags[language.languageCode]
                ? flags[language.languageCode]
                : language.languageCode}
            </MenuItem>
          ) : null,
        )}
      </Select>
    </FormControl>
  );
}

export default LanguageSelect;
